import React from "react";
import _ from "underscore";

import MenuItem from "material-ui/MenuItem";

import ISSUE_TYPES from "common/issue_types";
import Issues from "plugins/issues";
import getIssueTypeName from "utils/issues/editor/get_issue_type_name";
import {FormControl, InputLabel, Select} from "@material-ui/core";

function getAvailalbleIssueKeys() {
  return Object.keys(ISSUE_TYPES).filter(type => type !== "NOT");
}

function initialise() {
  const issueType = getAvailalbleIssueKeys()[0];
  return {
    issue_type: issueType,
    rules: {
      ...Issues[issueType.toLowerCase()].editor.initialise(),
    },
  };
}

function validate(issue) {
  const childIssue = issue.rules;
  return Issues[childIssue.issue_type.toLowerCase()].editor.validate(
    childIssue,
  );
}

class Component extends React.Component {
  render() {
    const {rules} = this.props;
    return (
      <div>
        <div className="issue-list">
          <div>{this.renderIssue(rules)}</div>
        </div>
      </div>
    );
  }

  renderIssue(issue, error, index) {
    if (!issue.issue_type) {
      return null;
    }
    const IssueComponent =
      issue.issue_type &&
      Issues[issue.issue_type.toLowerCase()].editor.component;
    if (!IssueComponent) {
      return null;
    }
    return (
      <div
        className="issue"
        key={index}
        style={{
          border: "1px solid #ddd",
          margin: "1em",
          padding: "1em",
        }}
      >
        <FormControl
          className="issue-type"
          style={{
            width: "20em",
            margin: "1em",
            minWidth: 120,
          }}
          disabled={
            this.props.isNonOverridableFieldsDisabled || this.props.disabled
          }
        >
          <InputLabel id={`issue-type-label-${index}`}>Issue type</InputLabel>
          <Select
            labelId={`issue-type-label-${index}`}
            value={issue.issue_type}
            onChange={event => {
              const value = event.target.value;
              this.updateType(event, null, value);
            }}
            MenuProps={{
              getContentAnchorEl: null,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              PaperProps: {
                style: {
                  width: "auto",
                  overflowX: "hidden",
                  maxHeight: 300,
                },
              },
            }}
          >
            {_.sortBy(
              getAvailalbleIssueKeys(),
              type => Issues[type.toLowerCase()].order,
            ).map(type => (
              <MenuItem value={type} key={type}>
                {getIssueTypeName(Issues, type)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <IssueComponent
          {...this.props}
          path={`${this.props.path}.0`}
          rules={issue.rules}
          rulesError={error && error.rulesError}
          onChange={this.updateRules}
        />
      </div>
    );
  }

  /* eslint-disable no-invalid-this, no-spaced-func, func-call-spacing */
  updateRules = change => {
    this.props.onChange({
      ...this.props.rules,
      rules: change,
    });
  };
  updateType = (event, idx, value) => {
    const rules = {
      ui_order_id: `${this.props.path}.0`,
      issue_type: value,
      rules: Issues[value.toLowerCase()].editor
        .initialise
        // issues[index].rules,
        (),
    };
    this.props.onChange(rules);
  };
  /* eslint-enable no-invalid-this */
}

export default {
  initialise,
  validate,
  component: Component,
};
